import firebase from "config/firebase";

const db = firebase.firestore();

export const fetchDataWithLoadMore = async ({
  collectionName,
  queryOptions,
  lastVisible,
  limitCount = 5,
}) => {
  const collectionRef = db.collection(collectionName);
  let collectionQuery = collectionRef;

  queryOptions.forEach((queryOption) => {
    collectionQuery = collectionQuery[queryOption.method](...queryOption.args);
  });

  if (lastVisible) {
    collectionQuery = collectionQuery.startAfter(lastVisible);
  }

  collectionQuery = collectionQuery.limit(limitCount);

  const querySnapshot = await collectionQuery.get();
  const data = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return {
    data,
    lastVisible: querySnapshot.docs[querySnapshot.docs.length - 1] || null,
    isLoadingMore: !!lastVisible,
    hasMore: querySnapshot.docs.length === limitCount,
  };
};

export const updateDocument = async ({ collectionName, docId, updateData }) => {
  const docRef = db.collection(collectionName).doc(docId);
  await docRef.update(updateData);
};

export const deleteDocument = async ({ collectionName, docId }) => {
  const docRef = db.collection(collectionName).doc(docId);
  await docRef.delete();
};

export const fetchDocumentById = async ({ collectionName, docId }) => {
  const docRef = db.collection(collectionName).doc(docId);
  const docSnapshot = await docRef.get();

  if (docSnapshot.exists) {
    return { id: docSnapshot.id, ...docSnapshot.data() };
  } else {
    throw new Error("Document not found");
  }
};
